// src/components/home/FilterChips.tsx
import React from 'react';
import { FilterChip } from './types';
 
interface FilterChipsProps {
  darkMode: boolean;
  chips: FilterChip[];
  activeFilter: string;
  onFilterChange: (filterId: string) => void;
}
 
export const FilterChips: React.FC<FilterChipsProps> = ({
  darkMode, chips, activeFilter, onFilterChange,
}) => {
  return (
    <div className="mb-6 flex items-center gap-2 overflow-x-auto pb-2 scrollbar-hide">
      {chips.map(chip => {
        const Icon = chip.icon;
        const isActive = activeFilter === chip.id;
        return (
          <button
            key={chip.id}
            onClick={() => onFilterChange(chip.id)}
            className="flex items-center gap-2 px-4 py-2 rounded-lg font-black text-xs whitespace-nowrap transition-all"
            style={{
              background: isActive ? '#e8a820' : darkMode ? '#0f2424' : '#e0f4f4',
              border: `2px solid ${isActive ? '#0d1a1a' : darkMode ? 'rgba(90,184,184,0.15)' : 'rgba(13,26,26,0.12)'}`,
              boxShadow: isActive ? '2px 2px 0 #0d1a1a' : 'none',
              color: isActive ? '#0d1a1a' : darkMode ? 'rgba(126,206,206,0.5)' : 'rgba(13,26,26,0.5)',
              letterSpacing: '0.5px',
            }}
          >
            <Icon style={{ fontSize: '10px' }} />
            <span>{chip.label.toUpperCase()}</span>
          </button>
        );
      })}
    </div>
  );
};